import { createFileRoute, notFound } from "@tanstack/react-router";
import { NotificationLogsDashboard } from "../../../../../components/notification-logs/notification-logs-dashboard";
import { trpc } from "@/lib/trpc";

export const Route = createFileRoute("/_app/projects/$projectSlug/_layout/analytics")({
  component: RouteComponent,
  loader: async ({ context, params }) => {
    const projectObj = await context.queryClient.ensureQueryData(
      trpc.projects.getBySlug.queryOptions({ projectSlug: params.projectSlug }),
    );

    if (!projectObj) {
      notFound();
    }

    return { project: projectObj };
  },
});

function RouteComponent() {
  const { project } = Route.useLoaderData();

  return (
    <div className="space-y-6">
      <NotificationLogsDashboard projectId={project.id} />
    </div>
  );
}
